import { render } from "./DataTypesFormDialog.vue?vue&type=template&id=72cddde5&scoped=true"
import script from "./DataTypesFormDialog.vue?vue&type=script&lang=js"
export * from "./DataTypesFormDialog.vue?vue&type=script&lang=js"

import "./DataTypesFormDialog.vue?vue&type=style&index=0&id=72cddde5&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72cddde5"]])

export default __exports__